<div class="nav-toggle-btn" (click)="onClick()">
    <div class="nav-toggle-btn__arrow">
        <span class="nav-toggle-btn__line"></span>
        <span class="nav-toggle-btn__line"></span>
        <span class="nav-toggle-btn__line"></span>
    </div>
    <div class="nav-toggle-btn__burger">
        <span class="nav-toggle-btn__line"></span>
        <span class="nav-toggle-btn__line"></span>
        <span class="nav-toggle-btn__line"></span>
    </div>
</div>
